/**
 * Hero 세로 크기를 현재 브라우저 뷰포트 높이에 맞춥니다.
 * 리사이즈/오리엔테이션 변경 시에도 동기화하여
 * 하단 Scroll 인디케이터가 항상 첫 화면에 보이도록 합니다.
 */
export function initHeroViewport(hero: HTMLElement): () => void {
  const sync = () => {
    const height = window.innerHeight;
    hero.style.height = `${height}px`;
    hero.style.minHeight = `${height}px`;
  };

  let frame = 0;
  const onResize = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(sync);
  };

  sync();
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);
  // 모바일 브라우저 UI 변화에 대응
  window.visualViewport?.addEventListener('resize', onResize);

  return () => {
    cancelAnimationFrame(frame);
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onResize);
    window.visualViewport?.removeEventListener('resize', onResize);
    hero.style.height = '';
    hero.style.minHeight = '';
  };
}
